export const SIMULATOR_COLUMN = 'SIMULATOR_COLUMN';
export const SIMULATOR_INDEX = 'SIMULATOR_INDEX';
export const SIMULATOR_LOADING_INDEX = 'SIMULATOR_LOADING_INDEX';
export const SIMULATOR_LOADING_SHOW = 'SIMULATOR_LOADING_SHOW';
export const SIMULATOR_OPTION = 'SIMULATOR_OPTION';
export const SIMULATOR_RESET = 'SIMULATOR_RESET';
export const SIMULATOR_SEARCH = 'SIMULATOR_SEARCH';
export const SIMULATOR_SHOW = 'SIMULATOR_SHOW';
